module.exports = __webpack_public_path__ + "static/media/origami10.8c471649.JPG";